export default {
  precision: 'Precisión'
}
